import FaveBizAPI from '../integrations/FaveBizAPI';

export default function logoutUser() {
  return FaveBizAPI.post('/v1/auth/logout', {});
}
